import React from "react";
import "./gradientWrapper.scss";
import classNames from "classnames";

type GradientWrapperProps = {
  disableForMobile?: boolean;
  disableForDesktop?: boolean;
  display: boolean;
  className?: string;
};

export const GradientWrapper: React.FC<
  React.PropsWithChildren<GradientWrapperProps>
> = ({
  children,
  disableForMobile,
  disableForDesktop,
  display = false,
  className,
}) => {
  if (!display) {
    return <>{children}</>;
  }

  return (
    <div
      className={classNames("gradient", className, {
        "gradient--disable-for-desktop": disableForDesktop,
        "gradient--disable-for-mobile": disableForMobile,
      })}
    >
      {children}
    </div>
  );
};
